import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ScreenCollapseOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2H13V11H22V9L15 9V2ZM9 22H11V13H2V15H9V22Z",
    fill: "currentColor"
  }));
}